module.exports = __webpack_public_path__ + "static/media/Technologybanner@2x.35b3b8d6.png";